import { isSquadCoinProduct, StoreOfferProduct } from '@common'
import cx from 'classnames'

import { isStoreSpecial } from '@/features/storefronts/productFilters'

import { SquadBustersHeading } from './components/heading/SquadBustersHeading'
import { SquadBustersSpecialHeading } from './components/heading/SquadBustersSpecialHeading'
import { SquadBustersOfferCardContent } from './components/SquadBustersOfferCardContent'
import { SquadPattern } from './components/SquadPattern'
import { SquadContainer } from './SquadContainer'
import { Countdown, Footer, ValueBadge } from '../../../shared'
import { Ribbon, Ribbons } from '../../shared/Ribbons'
import { OfferCardType } from '../../shared/types'

import styles from './SquadBustersCard.module.scss'

type Props = {
  product: StoreOfferProduct
  offerCardType?: OfferCardType
  ribbons: Ribbon[]
}

export function SquadBustersOfferCard({ product, ribbons, offerCardType }: Props) {
  const isMultiItemOffer = product.contents.length > 1
  const isSpecialOffer = offerCardType === 'special'
  const isStoreSpecialOffer = isStoreSpecial(product)

  const isCoinProduct = isSquadCoinProduct(product)
  return (
    <SquadContainer
      product={product}
      className={cx(styles.Container, {
        [styles.MultiItemContainer]: isMultiItemOffer,
        [styles.SingleItemContainer]: !isMultiItemOffer,
        [styles.SpecialOfferContainer]: isSpecialOffer,
        [styles.isCoinProduct]: isCoinProduct,
      })}
    >
      {!isSpecialOffer && <SquadPattern />}
      <Countdown product={product as StoreOfferProduct} />
      {!isCoinProduct && ribbons.length === 0 ? <ValueBadge product={product} /> : <Ribbons ribbons={ribbons} />}
      {isStoreSpecialOffer ? (
        <SquadBustersSpecialHeading product={product} />
      ) : (
        <SquadBustersHeading product={product} />
      )}
      <SquadBustersOfferCardContent product={product} />
      <Footer product={product} />
    </SquadContainer>
  )
}
